import React, { useEffect } from 'react'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

import ContactModal from './ContactModal'
import { ModalManager } from 'react-dynamic-modal';

import './index.css'

import ContactFlatImage from './../../../assets/img/contact/contact_flat.jpg'

export default function Contact() {

    useEffect(() => {
        console.log('contact page mounted')
    }, [])

    function openContactModal() {
        ModalManager.open(<ContactModal/>)
    }

    return (
        <section className="Contact" id="contact">
            <div className="container-fluid">
                <Row>
                    <Col className="center-vertical" md={6}>
                        <img src={ContactFlatImage} className="img-fluid" alt="contate nos" />
                    </Col>

                    <Col className="center-vertical" md={6}>
                        <h1 className="section-title"><span className="super-bold">Contate</span>-nos</h1>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                            of type and scrambled it to make a type specimen book.
                         </p>

                        <Button variant="secondary" onClick={() => {openContactModal()}}>Entrar em contato</Button>
                    </Col>
                </Row>
            </div>
        </section>
    )
}